<div class="sidebar" [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }">
  @if (!isSidebarCollapsed) {
    <div class="sidebar-header">
      <div class="e-input-group">
        <span class="e-input-group-icon ti ti-search"></span>
        <input
          ejs-textbox
          id="sidebar-search"
          class="e-input"
          type="text"
          autocomplete="off"
          placeholder="{{ 'search' | translate }}"
          [value]="searchTerm()"
          (input)="onSearchChange($any($event.target).value)"
        />
        @if (searchTerm()) {
          <span
            class="e-input-group-icon clear-icon ti ti-x"
            role="button"
            tabindex="0"
            (click)="clearSearch()"
            (keydown.enter)="clearSearch()"
          ></span>
        }
      </div>
    </div>
  }
  @if (isLoadingMenu()) {
    <div class="sidebar-menu-loading">
      <span class="sidebar-loading-spinner"></span>
    </div>
  } @else {
    <ul class="sidebar-menu">
      @for (category of filteredMenuItems(); track category.label) {
        @if (!isSidebarCollapsed) {
          <li class="sidebar-category-header">
            <span>{{ category.label | translate }}</span>
          </li>
        }
        @for (item of category.items; track item) {
          <ng-container
            [ngTemplateOutlet]="menuItem"
            [ngTemplateOutletContext]="{ $implicit: item }"
          />
        }
      }
    </ul>
  }

  <ng-template #menuItem let-data>
    <li class="p-1">
      <a
        class="sidebar-item"
        [routerLink]="data.routerLink"
        routerLinkActive="active"
        [ngClass]="{ 'menu-item-active': data.isOpen }"
        (click)="toggleMenuItem(data)"
      >
        <i [class]="data.icon"></i>
        <span class="sidebar-item-text">{{ data.label | translate }}</span>
        @if (data.id === "19000" && totalUnread() > 0 && !isSidebarCollapsed) {
          <span class="sidebar-badge">{{
            totalUnread() > 99 ? "99+" : totalUnread()
          }}</span>
        }
        @if (data.items && !isSidebarCollapsed) {
          <i
            class="ti ti-chevron-down sidebar-item-arrow"
            [ngClass]="{ rotated: data.isOpen }"
          ></i>
        }
      </a>
      @if (data.items && data.isOpen && !isSidebarCollapsed) {
        <ul style="margin-left: 1rem">
          @for (child of data.items; track child) {
            <ng-container
              [ngTemplateOutlet]="menuItem"
              [ngTemplateOutletContext]="{ $implicit: child }"
            />
          }
        </ul>
      }
    </li>
  </ng-template>
  <div class="sidebar-footer">
    @if (healthCheck()) {
      <div class="version-info sidebar-footer-collapse-hidden">
        <span>v{{ healthCheck()!.version }}</span> &middot;
        <span>{{ healthCheck()!.releasedAt }}</span>
      </div>
    }
  </div>
</div>
